import { Box, Grid2 } from '@mui/material';
import CustomButton from '@ui-components/Button/CustomButton';
import CustomTypography from '@ui-components/Typography/CustomTypography';
import HealthTeamIcon from '@assets/images/Health_professional_team.svg';
import './facility.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import FetchResumedConsultUsers from './FetchResumableConsults';
import {
  CONSULT_WAITING_SCREEN_ROUTE_PATH,
  FACILITY_CONSULT_CREATE_DASHBOARD_ROUTE_PATH,
  RE_SUBMIT_OR_CANCEL_CONSULT_ROUTE_PATH,
} from '../../routers/RoutPath';
import CustomSnackbar from '@ui-components/Snackbar/CustomSnackbar';
import { getUserFromStorage } from '../components/storageUtility';
import { useUpdateConsultStatus } from '../../API/hooks/waitingHook';

const RequestConsult = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = getUserFromStorage();
  const { consultStatus } = useUpdateConsultStatus(0, user?.userId ?? 0);
  const [openToast, setOpenToast] = useState(false);
  const [isSuccess, setIsSuccess] = useState<boolean | null>(null);
  const [message, setMessage] = useState('');
  const handleRequestConsult = () => {
    navigate(FACILITY_CONSULT_CREATE_DASHBOARD_ROUTE_PATH);
  };

  useEffect(() => {
    if (user?.isAssociatedFacilityInactive) {
      setMessage('Your facility is inactive. Please contact support.');
      setIsSuccess(false);
      setOpenToast(true);
    }
  }, [user]);

  useEffect(() => {
    console.log('consultStatus', consultStatus);
    if (consultStatus?.isWaitingRoom === true) {
      navigate(
        `${CONSULT_WAITING_SCREEN_ROUTE_PATH}?consultId=${consultStatus.consultId}`,
        {
          replace: true,
        }
      );
    } else if (consultStatus?.isErrorPage === true) {
      navigate(`${RE_SUBMIT_OR_CANCEL_CONSULT_ROUTE_PATH}`, {
        replace: true,
        state: { consultId: consultStatus.consultId },
      });
    }
  }, [consultStatus]);

  useEffect(() => {
    const msg = location?.state?.message;

    if (msg) {
      setMessage(msg);
      setIsSuccess(true);
      setOpenToast(true);
      globalThis.history.replaceState({}, document.title);
    }
  }, [location]);

  const [openResumeConsult, setOpenResumeConsult] = useState(false);
  const handleResumeConsult = (state: boolean) => {
    setOpenResumeConsult(state);
  };

  const handleClose_SnackBar = () => {
    setOpenToast(false);
  };

  return (
    <Box>
      <Box>
        {openToast && (
          <CustomSnackbar
            id="facility-actions-tost"
            successOrError={isSuccess ? 'success' : 'error'}
            open={openToast}
            handleClose={handleClose_SnackBar}
            toastrMessage={message}
          />
        )}
      </Box>
      <Box>
        <Grid2 container>
          <Grid2
            size={{ xs: 6, sm: 6, md: 6, lg: 6 }}
            className="text-align-left"
          >
            <CustomTypography id="title-request-consult" variant="h4">
              Request Consults
            </CustomTypography>
          </Grid2>
          <Grid2
            size={{ xs: 6, sm: 6, md: 6, lg: 6 }}
            className="text-align-right"
          >
            <CustomButton
              id="request-consult"
              variant="contained"
              color="secondary"
              onClick={() => {
                handleResumeConsult(true);
              }}
              disabled={user?.isAssociatedFacilityInactive}
            >
              Resume Consult
            </CustomButton>

            <Box>
              <FetchResumedConsultUsers
                openResumedConsultUsers={openResumeConsult}
                onConsultClose={() => handleResumeConsult(false)}
              />
            </Box>
          </Grid2>
        </Grid2>
      </Box>
      <Box>
        <Grid2 container className="pt-32">
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
            <Box>
              <Box>
                <HealthTeamIcon />
              </Box>
              <Box>
                <CustomButton
                  id="request-consult-button"
                  variant="contained"
                  size="large"
                  className="request-consult-button-width height-40"
                  onClick={() => {
                    handleRequestConsult();
                  }}
                  disabled={user?.isAssociatedFacilityInactive}
                >
                  Request Consult
                </CustomButton>
              </Box>
            </Box>
          </Grid2>
        </Grid2>
      </Box>
    </Box>
  );
};

export default RequestConsult;
